import Model from "@/lib/model/model";

export default class UploadedFile extends Model {
  filename = "";
  object = "";
  size = 0;
  url = "";
}
